// FYI
// packages/@guardian/src-foundations/src/animation.ts SYMLINKS TO
// packages/@guardian/source-foundations/src/animation.ts
const transitions = {
    short: '.2s cubic-bezier(.64, .57, .67, 1.53)',
    medium: '.3s ease-in-out',
    long: '.65s ease-in-out',
};
export { transitions };
//# sourceMappingURL=animation.js.map
